import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ControleCronService } from '../../services/requests/controle-cron.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: [
    './menu.component.css',
    './../../../assets/css/site/style.css'
  ]
})
export class MenuComponent implements OnInit, OnDestroy {
  isCampagnesDropdownOpen = false;
  isMachinesDropdownOpen = false;
  isSystemeDropdownOpen = false;
  isReceptionDropdownOpen = false;

  url = '';
  isAdmin = false;
  hasCronAlert = false;
  lateCronCount = 0;
  needsSchedule = false;

  private cronAlertSub?: Subscription;
  private cronCountSub?: Subscription;
  private scheduleCheckInterval?: any;
  private routerSub?: Subscription;

  constructor(
    private router: Router,
    private controleCronService: ControleCronService
  ) {}

  ngOnInit(): void {
    this.checkAuth();
    this.isAdmin = localStorage.getItem('isAdmin') === 'true';
    this.updateActiveRoute(this.router.url);
    this.setupCronSubscriptions();
    this.setupScheduleCheck();
    this.setupRouteListener();
  }

  private checkAuth(): void {
    const hasId = localStorage.getItem('id') !== null;
    const hasToken = localStorage.getItem('token') !== null;

    if (!hasId || !hasToken) {
      localStorage.clear();
      this.router.navigate(['/']);
    }
  }

  private setupCronSubscriptions(): void {
    if (!this.isAdmin) return;

    this.controleCronService.startAutoRefresh();
    this.cronAlertSub = this.controleCronService.hasLateCron$.subscribe(
      flag => this.hasCronAlert = flag
    );
    this.cronCountSub = this.controleCronService.lateCronCount$.subscribe(
      count => this.lateCronCount = count
    );
  }

  private setupScheduleCheck(): void {
    this.updateScheduleAlert();
    this.scheduleCheckInterval = setInterval(() => this.updateScheduleAlert(), 2000);
  }

  private setupRouteListener(): void {
    this.routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateActiveRoute(event.url);
      }
    });
  }

  private updateActiveRoute(url: string): void {
    const routes = ['dashboard', 'campagne', 'parametrage', 'ports', 'sms', 'users', 'suivi', 'archive', 'logs', 'stops', 'rechargement', 'strategies', 'system-connection', 'controle-cron', 'services', 'webhooks'];
    this.url = routes.find(path => url.includes(path)) || '';
    this.updateDropdownStates(url);
  }

  private updateDropdownStates(url: string): void {
    this.isCampagnesDropdownOpen = ['campagne', 'suivi', 'archive'].some(p => url.includes(p));
    this.isMachinesDropdownOpen = ['ports', 'system-connection', 'strategies', 'rechargement'].some(p => url.includes(p));
    this.isSystemeDropdownOpen = ['parametrage', 'users', 'logs', 'controle-cron'].some(p => url.includes(p));
    this.isReceptionDropdownOpen = ['services', 'webhooks'].some(p => url.includes(p));
  }

  private updateScheduleAlert(): void {
    this.needsSchedule = localStorage.getItem('needsSchedule') === 'true';
  }

  deconnexion(): void {
    localStorage.clear();
    this.router.navigate(['/']);
  }

  toggleDropdown(menu: 'campagnes' | 'machines' | 'systeme' | 'reception'): void {
    if (menu !== 'campagnes') this.isCampagnesDropdownOpen = false;
    if (menu !== 'machines') this.isMachinesDropdownOpen = false;
    if (menu !== 'systeme') this.isSystemeDropdownOpen = false;
    if (menu !== 'reception') this.isReceptionDropdownOpen = false;

    if (menu === 'campagnes') {
      this.isCampagnesDropdownOpen = !this.isCampagnesDropdownOpen;
    } else if (menu === 'machines') {
      this.isMachinesDropdownOpen = !this.isMachinesDropdownOpen;
    } else if (menu === 'reception') {
      this.isReceptionDropdownOpen = !this.isReceptionDropdownOpen;
    } else {
      this.isSystemeDropdownOpen = !this.isSystemeDropdownOpen;
    }
  }

  ngOnDestroy(): void {
    this.cronAlertSub?.unsubscribe();
    this.cronCountSub?.unsubscribe();
    this.routerSub?.unsubscribe();
    if (this.scheduleCheckInterval) {
      clearInterval(this.scheduleCheckInterval);
    }
  }
}
